import { createEvent, createStore } from 'effector';
import i18n from '@shared/config/i18n';
import { CustomFieldsGate } from '../detail-sdui/model';
import { TicketGate } from '../ticket/ticket.model';

const { t } = i18n;

export const tabs = ({
  isNew,
  hasAccountsTab,
  isIncident,
}: {
  isNew?: boolean;
  hasAccountsTab?: boolean;
  isIncident?: boolean;
}) => {
  const tabs = [
    {
      value: 'info',
      onCreateIsDisabled: false,
      label: t('information'),
    },
  ];

  if (hasAccountsTab) {
    tabs.push({
      value: 'invoces',
      onCreateIsDisabled: false,
      label: t('BillsAndPayments'),
    });
  }

  if (isIncident) {
    tabs.push({
      value: 'related-tickets',
      onCreateIsDisabled: false,
      label: t('ContactingApplications'),
    });
  }

  if (!isNew) {
    tabs.push({
      value: 'works',
      onCreateIsDisabled: true,
      label: t('TicketTasks'),
    });
  }

  return tabs;
};

export const changeTab = createEvent<string>();

export const $currentTab = createStore<string>('info').reset([
  CustomFieldsGate.open,
  TicketGate.open,
]);
